import { FC, CSSProperties } from "react";
import { ReactComponent as MailIcon } from "@/assets/icons/mail.svg";
import { ReactComponent as SearchIcon } from "@/assets/icons/search.svg";
import { ReactComponent as HelpIcon } from "@/assets/icons/help-circle.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import "./style.scss";

interface InputPropsTypes {
  placeholder?: string;
  id?: string;
  value: any;
  withTooltip?: boolean;
  hint?: string;
  style?: CSSProperties;
  disabled?: boolean;
  type?: InputType;
  withIcon?: boolean;
  required?: boolean;
  onChange?: (e: any) => void;
  onKeyDown?: (e: any) => void;
  isError?: boolean;
  errorText?: string;
}

type InputType = "text" | "email" | "search" | "number";

const Input: FC<InputPropsTypes> = ({
  type = "text",
  withIcon = true,
  placeholder = "input",
  value,
  style,
  withTooltip = false,
  hint = "hint..",
  disabled,
  onKeyDown,
  onChange,
  required = false,
  id,
  isError = false,
  errorText,
}) => {
  const getIcons = (type: InputType) => {
    switch (type) {
      case "email":
        return <MailIcon className="input-icon" />;
      case "search":
        return <SearchIcon className="input-icon" />;
      default:
        return "";
    }
  };

  return (
    <>
      <div
       style={style}
        className={`input-wrapper ${
          withIcon && type !== "text" ? "with-icon" : ""
        }`}
      >
        {withIcon && getIcons(type)}
        <input
          className={`input-component ${
            withIcon && type !== "text" ? "with-icon" : ""
          } ${disabled ? "disabled" : ""}`}
         
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          value={value}
          type={type}
          disabled={disabled}
          autoComplete="false"
          required={required}
          id={id}
        />
        {withTooltip && (
          <HelpIcon data-tooltip-content={hint} className="help-icon" />
        )}
      </div>
      {isError && (
        <span className="input-component-error-text">{errorText}</span>
      )}
      <ReactTooltip anchorSelect=".help-icon" place="top" />
    </>
  );
};

export default Input;
